import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function PasswordResetCancelled() {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h5" align="center" sx={{ marginBottom: 10 }}>
        {t('password_reset_cancelled')}
      </Typography>
    </>
  );
}
